<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,3C12,3,4,3,4,3C3.45,3,3,3.45,3,4C3,4,3,12,3,12C3,12.55,3.45,13,4,13C4,13,12,13,12,13C12.55,13,13,12.55,13,12C13,12,13,4,13,4C13,3.45,12.55,3,12,3C12,3,12,3,12,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Stop',
} as DefineComponent
</script>
